<template>
  <b-card class="upcoming-site-visits" v-if="hasRight(user, 'dashboard', 'view')" no-body>
    <b-card-body>
      <b-table
        :items="siteVisits"
        :fields="fields"
        per-page="5"
        small
        striped
        responsive
        tbody-tr-class="clickable-row"
        @row-clicked="onRowClicked"
      >
        <template #cell(site_visit_date)="data">
          {{ formatSiteVisitDate(data.item.site_visit_date) }}
        </template>
        <template #cell(remarks)="data">
          {{ data.item.remarks.vehicleRemarks ? data.item.remarks.vehicleRemarks : data.item.remarks.driverRemarks ? data.item.remarks.driverRemarks : data.item.remarks.remarks  }}
        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BTable } from 'bootstrap-vue';
import { hasRight } from '@/utils/auth';
import { dashboardGet } from './dashboardApi';
import moment from 'moment';

export default {
  name: 'UpcomingSiteVisits',
  components: {
    BCard,
    BCardBody,
    BTable,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default: null,
    },
    dashboardData: { type: Object, default: null },
    useAggregate: { type: Boolean, default: false },
    baseApi: {
      type: String,
      default: () => process.env.VUE_APP_APIENDPOINT || '',
    },
    accessToken: {
      type: String,
      default: () => localStorage.getItem('accessToken') || '',
    },
  },
  data() {
    return {
      fields: [
        { key: 'lead_name', label: 'Lead Name' },
        { key: 'site_visit_date', label: 'Site Visit Date' },
        { key: 'project_name', label: 'Project' },
        { key: 'remarks', label: 'Remarks' },
      ],
      siteVisits: [],
    };
  },
  watch: {
    dashboardData: {
      deep: true,
      handler(val) {
        if (val && val.upcoming_visits != null && hasRight(this.user, 'dashboard', 'view')) {
          const arr = Array.isArray(val.upcoming_visits) ? val.upcoming_visits : [];
          this.siteVisits = arr.map(item => ({
            ...item,
            site_visit_date: item.visitdate || item.site_visit_date || '',
            project_name: item.project_name || item.projectname || '-',
          }));
        }
      },
    },
    filters: {
      deep: true,
      immediate: true,
      handler() {
        if (!hasRight(this.user, 'dashboard', 'view')) return;
        if (this.useAggregate) {
          if (this.dashboardData && this.dashboardData.upcoming_visits != null) {
            const arr = Array.isArray(this.dashboardData.upcoming_visits) ? this.dashboardData.upcoming_visits : [];
            this.siteVisits = arr.map(item => ({ ...item, site_visit_date: item.visitdate || item.site_visit_date || '', project_name: item.project_name || item.projectname || '-' }));
          }
          return;
        }
        if (this.dashboardData && this.dashboardData.upcoming_visits != null) {
          const arr = Array.isArray(this.dashboardData.upcoming_visits) ? this.dashboardData.upcoming_visits : [];
          this.siteVisits = arr.map(item => ({ ...item, site_visit_date: item.visitdate || item.site_visit_date || '', project_name: item.project_name || item.projectname || '-' }));
          return;
        }
        this.fetchUpcomingSiteVisitsData();
      },
    },
    user: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (hasRight(newVal, 'dashboard', 'view')) {
          if (this.useAggregate) {
            if (this.dashboardData && this.dashboardData.upcoming_visits != null) {
              const arr = Array.isArray(this.dashboardData.upcoming_visits) ? this.dashboardData.upcoming_visits : [];
              this.siteVisits = arr.map(item => ({ ...item, site_visit_date: item.visitdate || item.site_visit_date || '', project_name: item.project_name || item.projectname || '-' }));
            }
            return;
          }
          this.fetchUpcomingSiteVisitsData();
        } else {
          this.siteVisits = [];
        }
      },
    },
  },
  methods: {
    hasRight, // Make the helper available in the template
    onRowClicked(item) {
      const raw = item && (item.lead_id ?? item.clientname);
      if (raw == null || raw === '') return;
      const id = Number(raw);
      if (!Number.isFinite(id) || id <= 0) return;
      this.$router.push(`/followup/followupinfo?id=${id}`).catch(() => {});
    },
    formatSiteVisitDate(val) {
      if (val == null || val === '') return '';
      const m = moment(val);
      return m.isValid() ? m.format('DD-MM-YYYY HH:mm:ss') : String(val);
    },
    async fetchUpcomingSiteVisitsData() {
      if (!hasRight(this.user, 'dashboard', 'view')) return;
      if (this.useAggregate || (this.dashboardData && this.dashboardData.upcoming_visits != null)) {
        if (this.dashboardData && this.dashboardData.upcoming_visits != null) {
          const arr = Array.isArray(this.dashboardData.upcoming_visits) ? this.dashboardData.upcoming_visits : [];
          this.siteVisits = arr.map(item => ({ ...item, site_visit_date: item.visitdate || item.site_visit_date || '', project_name: item.project_name || item.projectname || '-' }));
        }
        return;
      }
      try {
        const response = await dashboardGet(this.baseApi, this.accessToken, '/dashboard/crm/upcoming-visits', this.filters);
        const raw = response.data && response.data.data;
        const arr = Array.isArray(raw) ? raw : [];
        this.siteVisits = arr.map(item => ({ ...item, site_visit_date: item.visitdate || item.site_visit_date || '', project_name: item.project_name || item.projectname || '-' }));
      } catch (error) {
        console.error('Error fetching upcoming site visits data:', error);
        // Handle error
      }
    },
  },
};
</script>

<style scoped>
.upcoming-site-visits {
  margin-top: 20px;
}
.upcoming-site-visits ::v-deep tr.clickable-row {
  cursor: pointer;
}
.upcoming-site-visits ::v-deep tr.clickable-row:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>